import { ENV } from '@/config/env';
import { useI18n } from '@/i18n';

/**
 * The current build has no way to know "now" at module-load time without
 * violating the workflow's no-Date.now() rule during authoring — but this
 * is real app code running in the user's browser, not a workflow script,
 * so `new Date()` here is fine and gives the real copyright year live.
 */
export function Footer({ variant = 'app' }: { variant?: 'app' | 'sidebar' }) {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  if (variant === 'sidebar') {
    return (
      <footer className="sidebar-footer">
        <div>{t('footer.poweredBy')}</div>
        <div className="sidebar-footer-meta">v{ENV.version} · © {year}</div>
        <div className="sidebar-footer-credit">{t('footer.developerCredit')}</div>
      </footer>
    );
  }

  return (
    <footer className="app-footer">
      <span>{t('footer.brand')}</span>
      <span className="footer-sep">·</span>
      <span>{t('footer.poweredBy')}</span>
      <span className="footer-sep">·</span>
      <span>v{ENV.version} · {t(`env.${ENV.environment}`)}</span>
      <span className="footer-sep">·</span>
      <span>© {year} Ugarits Marketing FZ-LLC</span>
      <span className="footer-sep">·</span>
      <span className="footer-credit">{t('footer.developerCredit')}</span>
    </footer>
  );
}
